var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrival(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.59017 2.61719V9.30339L4.49349 8.22428L3.80664 6.37695L2.75684 6.13932V10.3499L16.2139 13.9176V13.9144C16.3098 13.9379 16.4081 13.9499 16.5068 13.9502C16.8384 13.9502 17.1563 13.8185 17.3907 13.5841C17.6251 13.3497 17.7568 13.0317 17.7568 12.7002C17.7568 12.4097 17.6555 12.1283 17.4705 11.9043C17.2854 11.6803 17.0281 11.5278 16.7428 11.473L12.5811 10.3597L10.2438 2.98828L8.59017 2.61719ZM2.75684 16.4502V18.1169H17.7568V16.4502H2.75684Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrival);
export default __webpack_public_path__ + "static/media/arrival.8bb9c7b5c2994cc017a5da5e2ef91135.svg";
export { ForwardRef as ReactComponent };